import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { parse } from 'date-fns';

import { ActivityPlanningDateSelectionInterface } from '~/organizer/activity-planning/components/shared/date-selection/interfaces/date-selection.interface';
import {
  isDateSelectionRangeValid,
  isDateSelectionValidRecurrence,
  isDateSelectionValidSingleDate,
} from '~/organizer/activity-planning/helpers/date-selection.helper';

export function dateSelectionValidator(): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    const dateSelectionValue: ActivityPlanningDateSelectionInterface =
      control.value;

    let validationErrors: ValidationErrors | null = null;

    if (
      dateSelectionValue?.recurrent &&
      !isDateSelectionRangeValid(dateSelectionValue)
    ) {
      validationErrors = { invalidDateRange: true };
    }

    if (
      !dateSelectionValue ||
      (!isDateSelectionValidRecurrence(dateSelectionValue) &&
        !isDateSelectionValidSingleDate(dateSelectionValue))
    ) {
      validationErrors = { ...validationErrors, invalidDateSection: true };
    }

    if (dateSelectionValue?.startTime && dateSelectionValue?.startDate) {
      const now = new Date();

      const selectedDate = parse(
        dateSelectionValue.startDate,
        'yyyy-MM-dd',
        now
      );
      const selectedTimeAsDate = parse(
        dateSelectionValue.startTime,
        'HH:mm',
        now
      );

      const selectedDateAndHours = new Date(
        selectedDate.setHours(
          selectedTimeAsDate.getHours(),
          selectedTimeAsDate.getMinutes()
        )
      );

      validationErrors =
        selectedDateAndHours < now
          ? { ...validationErrors, minTime: true }
          : validationErrors;
    }

    return validationErrors;
  };
}
